module.exports = __webpack_public_path__ + "img/steder_lapper_recife.816f5201.png";